/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceHistoryCdkModel } from '../models/ServiceHistoryCdkModel';
import type { ServiceHistoryModel } from '../models/ServiceHistoryModel';
import type { ServiceHistoryProofOfHistoryModel } from '../models/ServiceHistoryProofOfHistoryModel';
import type { ServiceHistoryProofsOfHistoryModel } from '../models/ServiceHistoryProofsOfHistoryModel';
import type { ServiceHistoryVauxhallModel } from '../models/ServiceHistoryVauxhallModel';
import type { VehicleServiceHistoryDetailsResponse } from '../models/VehicleServiceHistoryDetailsResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ServiceHistoryService {

  /**
   * @param regNo 
   * @param vin 
   * @returns ServiceHistoryModel Success
   * @throws ApiError
   */
  public static postServiceHistoryInit(
regNo?: string,
vin?: string,
): CancelablePromise<ServiceHistoryModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-history/init',
      query: {
        'regNo': regNo,
        'vin': vin,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param serviceHistoryId 
   * @returns ServiceHistoryCdkModel Success
   * @throws ApiError
   */
  public static getServiceHistoryCdk(
serviceHistoryId: number,
): CancelablePromise<ServiceHistoryCdkModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-history/{serviceHistoryId}/cdk',
      path: {
        'serviceHistoryId': serviceHistoryId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param serviceHistoryId 
   * @returns VehicleServiceHistoryDetailsResponse Success
   * @throws ApiError
   */
  public static getServiceHistoryCdkDetails(
serviceHistoryId: string,
): CancelablePromise<VehicleServiceHistoryDetailsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-history/{serviceHistoryId}/cdk/details',
      path: {
        'serviceHistoryId': serviceHistoryId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param serviceHistoryId 
   * @param userId 
   * @param branchId 
   * @returns any Created
   * @throws ApiError
   */
  public static postServiceHistoryCdkLookup(
serviceHistoryId: number,
userId: number,
branchId: number = 1,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-history/{serviceHistoryId}/cdk/lookup',
      path: {
        'serviceHistoryId': serviceHistoryId,
      },
      query: {
        'userId': userId,
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param serviceHistoryId 
   * @returns ServiceHistoryVauxhallModel Success
   * @throws ApiError
   */
  public static getServiceHistoryVauxhall(
serviceHistoryId: number,
): CancelablePromise<ServiceHistoryVauxhallModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-history/{serviceHistoryId}/vauxhall',
      path: {
        'serviceHistoryId': serviceHistoryId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param serviceHistoryId 
   * @param userId 
   * @returns any Created
   * @throws ApiError
   */
  public static postServiceHistoryVauxhallLookup(
serviceHistoryId: number,
userId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-history/{serviceHistoryId}/vauxhall/lookup',
      path: {
        'serviceHistoryId': serviceHistoryId,
      },
      query: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param serviceHistoryId 
   * @returns ServiceHistoryProofsOfHistoryModel Success
   * @throws ApiError
   */
  public static getServiceHistoryProofOfService(
serviceHistoryId: number,
): CancelablePromise<ServiceHistoryProofsOfHistoryModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-history/{serviceHistoryId}/proof-of-service',
      path: {
        'serviceHistoryId': serviceHistoryId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param serviceHistoryId 
   * @param userId 
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
  public static postServiceHistoryProofOfService(
serviceHistoryId: number,
userId: number,
formData?: {
file: Blob;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-history/{serviceHistoryId}/proof-of-service',
      path: {
        'serviceHistoryId': serviceHistoryId,
      },
      query: {
        'userId': userId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param fileUid 
   * @param userId 
   * @returns ServiceHistoryProofOfHistoryModel Success
   * @throws ApiError
   */
  public static deleteServiceHistoryProofOfService(
fileUid: string,
userId?: number,
): CancelablePromise<Array<ServiceHistoryProofOfHistoryModel>> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-history/{fileUid}/proof-of-service',
      path: {
        'fileUid': fileUid,
      },
      query: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param regNo 
   * @returns ServiceHistoryProofOfHistoryModel Success
   * @throws ApiError
   */
  public static getServiceHistoryLastEdit(
regNo?: string,
): CancelablePromise<Array<ServiceHistoryProofOfHistoryModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-history/last-edit',
      query: {
        'regNo': regNo,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

}
